<template lang="html">
  <root class="admin-configurations">

    <admin-nav></admin-nav>
    <page-header name="configurations" :count="false"></page-header>

    <!-- Data -->
    <div class="container">

      <!-- Add new -->
      <div class="row">
        <div class="col m10 offset-m1">
          <div class="row">
            <div class="col m4">
              <div class="mui-textfield">
                <label>Service charge (Normal order)</label>
                <input type="text" v-model="serviceCharges.normal">
              </div>
            </div>
            <div class="col m4">
              <div class="mui-textfield">
                <label>Service charge (Instant order)</label>
                <input type="text" v-model="serviceCharges.instant">
              </div>
            </div>
            <div class="col m4">
              <div class="mui-textfield">
                <label>App version number (latest release)</label>
                <input type="text" v-model="appVersion">
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col m6">
              <div class="switch">
                <label>
                  Activate tester user
                  <input type="checkbox" v-model="isTesterUserActive">
                  <span class="lever"></span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col m2 offset-m5">
          <a class="waves-effect waves-light btn" @click="update">Update</a>
        </div>
      </div>
    </div>

  </root>
</template>

<script>
import * as firebase from 'firebase'

export default {
  data: () => {
    return {
      serviceCharges: {
        normal: '',
        instant: '',
      },
      appVersion: '',
      isTesterUserActive: false,

      isSending: false,
    }
  },

  methods: {
    update() {

      // Field is required
      if (
        !this.serviceCharges.normal ||
        !this.serviceCharges.instant ||
        !this.appVersion
      ) {
        Materialize.toast("All fields are required", 4000)
        return
      }

      this.isSending = true

      const updateServiceCharges = firebase.database()
        .ref('config/service_charges')
        .update(this.serviceCharges)
      const updateAppVersion = firebase.database()
        .ref('config')
        .update({ app_version: this.appVersion })
      const updateTestingUser = firebase.database()
        .ref('config/testing_user')
        .update({ is_active: this.isTesterUserActive })

      Promise.all([updateServiceCharges, updateAppVersion, updateTestingUser])
        .then (() => {
          Materialize.toast("Updated", 4000)
          this.isSending = false
        })
    },

    collect() {
      firebase.database()
      .ref('config')
      .once('value')
      .then(configSnap => {
        const config = configSnap.val()
        this.serviceCharges.normal = config.service_charges.normal
        this.serviceCharges.instant = config.service_charges.instant
        this.appVersion = config.app_version
        this.isTesterUserActive = config.testing_user.is_active
      })
    },
  },

  // Mounted
  mounted() {
    this.collect()
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/Admin/Configurations.vue